import { render, staticRenderFns } from "./AlertAccountPayment.vue?vue&type=template&id=a945953c&scoped=true&"
import script from "./AlertAccountPayment.vue?vue&type=script&lang=js&"
export * from "./AlertAccountPayment.vue?vue&type=script&lang=js&"
import style0 from "./AlertAccountPayment.vue?vue&type=style&index=0&id=a945953c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a945953c",
  null
  
)

export default component.exports